export interface TabListProps {
  children?: React.ReactNode;
}

export default function TabList({ children }: TabListProps) {
  return (
    <ul className="tabs__tab-list" role="tablist">
      {children}
    </ul>
  );
}
